<template>
  <div id="MyTransfer">
    <div
      class="filter-dash-btn"
      :class="{ 'is-disabled': disabled }"
      @click="handleClick"
    >
      <div class="filter-checked-app" v-if="selectArr.length > 0">
        <div class="checked-app-item" :title="selectedLabelText">
          <span>{{ selectedLabelText }}</span>
        </div>
        <i
          v-if="!disabled"
          class="el-icon-circle-close checked-clear anticon anticon-close-circle"
          @click.stop="handleClear"
        ></i>
      </div>
      <div class="filter-tips-default" v-else>
        {{ disabled ? '未选择人员' : '点击选择人员' }}
      </div>
    </div>

    <el-dialog
      :append-to-body="true"
      title="请选择人员"
      :visible.sync="selectDia"
      width="40%"
      :before-close="handleClose"
      @close="handleClosed"
    >
      <div class="container">
        <div class="left">
          <div class="leftHead">
            <i class="el-icon-search"></i>
            <el-input placeholder="输入关键词进行过滤" v-model="filterText"></el-input>
          </div>
          <div class="leftBody">
            <el-tree
              v-if="isLoading"
              :data="userList"
              ref="tree"
              node-key="id"
              :filter-node-method="filterNode"
            >
              <span class="custom-tree-node" slot-scope="{ data }">
                <el-checkbox
                  v-if="data.is_department == '0'"
                  :checked="!!data.checked"
                  :label="data.id"
                  @change="handleNodeChange(data)"
                >
                  {{ data.show_name }}
                </el-checkbox>
                <span v-else>{{ data.show_name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="right">
          <div
            v-for="item in selectArr"
            :key="item.id"
            class="h3-organization-selected"
            @click="removeItem(item)"
          >
            <i class="el-icon-user aufontAll h-icon-all-user-o"></i>
            <div class="h3-organization-selected-name">{{ item.label }}</div>
            <i class="aufontAll el-icon-close h-icon-all-close"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectDia = false">取消</el-button>
        <el-button type="primary" @click="getCheckedNodes">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: '',
      cache_department_id: '',
      userList: [],
      member_id: '',
      company_id: '',
      details_project_id: '',
      details_project_status: '',
      filterText: '',
      selectArr: [],
      selectDia: false,
      isLoading: true,
    }
  },
  props: {
    selectedId: {
      type: Array,
      default: () => [],
    },
    isSelected: {
      type: String,
      default: '',
    },
    nextIndex: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    filterText(val) {
      if (this.$refs.tree) {
        this.$refs.tree.filter(val)
      }
    },
    selectedId: {
      handler(val) {
        const incomingIds = this.normalizeSelectedIds(val)
        const currentIds = this.normalizeSelectedIds(
          this.selectArr.map((item) => item.id)
        )
        if (incomingIds.join(',') === currentIds.join(',')) return
        this.syncSelectedState(incomingIds)
      },
      deep: true,
    },
  },
  computed: {
    selectedLabelText() {
      return this.selectArr.map((item) => item.label).join('、')
    },
  },
  methods: {
    normalizeSelectedIds(ids) {
      return (Array.isArray(ids) ? ids : [])
        .map((id) => String(id))
        .filter(Boolean)
    },
    async getUserListWith() {
      const param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/simple_member',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.userList = res.datas.listInfo || []
      this.walkNodes(this.userList, (node) => {
        this.$set(node, 'checked', !!node.checked)
      })
      this.syncSelectedState()
    },
    syncSelectedState(selectedIdsValue) {
      const selectedIds = new Set(
        this.normalizeSelectedIds(selectedIdsValue || this.selectedId)
      )
      const nextSelected = []
      this.walkNodes(this.userList, (node) => {
        const checked =
          node.is_department != '1' && selectedIds.has(String(node.id))
        this.$set(node, 'checked', checked)
        if (checked) {
          nextSelected.push({
            id: String(node.id),
            label: node.show_name,
          })
        }
      })
      this.selectArr = nextSelected
    },
    walkNodes(nodes, callback) {
      ;(nodes || []).forEach((node) => {
        callback(node)
        if (node.children && node.children.length > 0) {
          this.walkNodes(node.children, callback)
        }
      })
    },
    handleNodeChange(node) {
      this.$set(node, 'checked', !node.checked)
      const index = this.selectArr.findIndex((item) => item.id == node.id)
      if (node.checked && index === -1) {
        this.selectArr.push({
          id: String(node.id),
          label: node.show_name,
        })
      }
      if (!node.checked && index !== -1) {
        this.selectArr.splice(index, 1)
      }
      this.$emit('my-transfer-change', this.selectArr)
    },
    removeItem(val) {
      this.walkNodes(this.userList, (node) => {
        if (String(node.id) === String(val.id)) {
          this.$set(node, 'checked', false)
        }
      })
      const index = this.selectArr.findIndex((item) => item.id == val.id)
      if (index !== -1) {
        this.selectArr.splice(index, 1)
      }
      this.$emit('my-transfer-change', this.selectArr)
    },
    filterNode(value, data) {
      if (!value) return true
      return String(data.show_name || '').indexOf(value) !== -1
    },
    handleClear() {
      if (this.disabled) return
      this.walkNodes(this.userList, (node) => {
        this.$set(node, 'checked', false)
      })
      this.selectArr = []
      this.$emit('my-transfer-change', this.selectArr)
    },
    getCheckedNodes() {
      if (this.disabled) return
      this.$emit('my-transfer-change', this.selectArr)
      this.selectDia = false
    },
    handleClick() {
      if (this.disabled) return
      this.selectDia = true
    },
    handleClose() {
      this.selectDia = false
    },
    handleClosed() {
      this.filterText = ''
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    this.getUserListWith()
  },
}
</script>

<style lang="less" scoped>
#MyTransfer {
  display: flex;
  align-items: center;
  font-size: 14px;
}

#MyTransfer .filter-dash-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  border: 1px solid #c9ccd8;
  color: #c9ccd8;
  cursor: pointer;
  transition: all 0.3s;
}

#MyTransfer .filter-dash-btn:hover {
  border: 1px dashed #107fff;
}

#MyTransfer .filter-dash-btn.is-disabled {
  cursor: not-allowed;
  background-color: #fafafa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}

#MyTransfer .filter-dash-btn.is-disabled:hover {
  border: 1px solid #e4e7ed;
}

#MyTransfer .filter-tips-default {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 15px;
  align-items: center;
  width: 100%;
  height: 32px;
  transition: all 0.3s;
}

#MyTransfer .filter-dash-btn:hover .filter-tips-default {
  color: #107fff;
}

.filter-checked-app {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  min-width: 0;
  padding: 4px 28px 4px 4px;
}

.checked-app-item {
  flex: 1;
  min-width: 0;
  padding: 2px 6px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
}

.checked-app-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.checked-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #ccc;
  transition: color 0.2s;
}

.checked-clear:hover {
  color: #aaa;
}

/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}

/deep/ .el-dialog__header {
  padding: 16px 24px;
  color: #304265;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  .el-dialog__title {
    margin: 0;
    color: #304265;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
}

/deep/.el-dialog__body {
  padding: 0;
  font-size: 14px;
  line-height: 1.5;

  .container {
    width: 100%;
    display: flex;

    .left {
      width: 55%;
      border-right: 1px solid #e8e8e8;
      box-sizing: border-box;

      .leftHead {
        display: flex;
        align-items: center;
        padding: 12px 24px;
        border-bottom: 1px solid #e8e8e8;

        i {
          color: #aaa;
        }

        .el-input__inner {
          height: 22px;
          border: none;
          padding-left: 10px;
        }
      }

      .leftBody {
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 10px;
        height: 344px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }

    .right {
      box-sizing: border-box;
      padding: 16px;
      width: 45%;
      min-height: 344px;
      overflow-y: auto;
    }
  }
}

.h3-organization-selected {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
}

.h3-organization-selected-name {
  flex: 1;
  margin: 0 8px;
  word-break: break-all;
}
</style>
